import { Directive, ElementRef, Input, OnInit } from '@angular/core';

// Minimal no-op directives to satisfy Angular templates that use MDC top app bar attributes.
// These do not provide MDC behavior; they only prevent template compilation errors.

@Directive({
  selector: '[mdcTopAppBar]'
})
export class MdcTopAppBarDirective implements OnInit {
  @Input() viewport?: HTMLElement;
  @Input() fixedAdjust?: HTMLElement;
  @Input() dense?: boolean;

  constructor(private el: ElementRef<HTMLElement>) {}
  ngOnInit(): void {
    // no-op: placeholder for potential integration with MDC if needed in the future
  }
}

@Directive({
  selector: '[mdcTopAppBarRow]'
})
export class MdcTopAppBarRowDirective {}

@Directive({
  selector: '[mdcTopAppBarSection]'
})
export class MdcTopAppBarSectionDirective {
  @Input('alignStart') alignStart?: any;
  @Input('alignEnd') alignEnd?: any;
}

@Directive({
  selector: '[mdcTopAppBarTitle]'
})
export class MdcTopAppBarTitleDirective {}

@Directive({
  selector: '[mdcTopAppBarNavIcon]'
})
export class MdcTopAppBarNavIconDirective {}

@Directive({
  selector: '[mdcTopAppBarAction]'
})
export class MdcTopAppBarActionDirective {
  @Input() label?: string;
}
